import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { isSameDay, isToday } from 'date-fns';

import { DayContainer } from './styles';
import { useDay } from '@spa/shared/hooks/dateRange';

const Day = ({ dayLabel, date, dateRange = {} }) => {
  const dayRef = useRef();

  const { startDate, endDate } = dateRange;
  const { disabledDate, onClick, isSelectedStartOrEnd } = useDay(dayRef, date, dateRange);

  const dayClasses = {
    disabled: disabledDate || !date,
    selected: isSelectedStartOrEnd || isSameDay(date, startDate) || isSameDay(date, endDate),
    today: date && isToday(date)
  };

  const className = Object.keys(dayClasses)
    .filter(name => dayClasses[name])
    .join(' ');

  return (
    <DayContainer ref={dayRef} tabIndex={dayClasses.disabled ? null : '-1'} className={className} onClick={onClick}>
      {dayLabel}
    </DayContainer>
  );
};

Day.propTypes = {
  dayLabel: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  dateRange: PropTypes.object
};

export default Day;
